<div class="main-container">
    <div class="login-container">
        <div class="loading-block" *ngIf="loading">
            <img class="loader" src="./assets/images/loader.gif"/>
            <div class="message">{{ loadingMessage }}</div>
        </div>
    </div>
</div>
